import styled from 'styled-components';
import { useCurrentUser } from 'hooks/selectors';
import { DoNotRunIcon, InfoIcon } from 'components/Icons';
import Tooltip from 'components/Tooltip';
import { Vehicle } from 'types/vehicle';

type Props = {
  vehicle: Pick<Vehicle, 'do_not_run' | 'do_not_run_note'>;
  position?: 'top-left' | 'top-right';
};

const Wrapper = styled.div<{ position: 'top-left' | 'top-right' }>`
  position: absolute;
  top: 8px;
  ${({ position }) => (position === 'top-right' ? 'right: -4px;' : 'left: -4px;')}
  z-index: 1;
  overflow: visible;
  display: flex;
  align-items: center;
  gap: 2px;
`;

const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const DoNotRunBanner = ({ vehicle, position = 'top-right' }: Props) => {
  const user = useCurrentUser();
  const isAdmin = user?.role === 'admin';

  if (!isAdmin || !vehicle?.do_not_run) return null;

  const note = vehicle.do_not_run_note;

  return (
    <Wrapper position={position} onClick={e => e.stopPropagation()}>
      <DoNotRunIcon />
      {note ? (
        <Tooltip light isTextOverflown title={note} arrow>
          <InfoWrapper>
            <InfoIcon />
          </InfoWrapper>
        </Tooltip>
      ) : null}
    </Wrapper>
  );
};

export default DoNotRunBanner;
